import {
  ElementRef,
  EventEmitter,
  Injectable,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { FlyoutLoggedinUserComponent } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.component';
@Injectable({
  providedIn: 'root'
})
export class BusinessUserComponentHelper {
  @Output() modalServiceRef = new EventEmitter<any>();
  showModal = false;
  bsModalRef: BsModalRef;
  config = { animated: false };

  @ViewChild('triggerElement1') triggerElement1: ElementRef;
  protected unsubscribe: Subject<void> = new Subject();
  constructor(
    private cookieHelper: CookieHelper,
    private modalService: BsModalService,
    public el: ElementRef,
    private renderer: Renderer2,
    private loggingService: LoggingService
  ) {}

  getProfileSelector(obj) {
    return !!obj?.header?.enableNewProfileSelector;
  }

  getBusinessType(obj) {
    return obj.header?.auxiliaryNavigation.get('profileSelector')
      ? obj.header.auxiliaryNavigation.get('profileSelector').details
      : null;
  }

  getPassCorpName(hasBusinessOnly) {
    if (hasBusinessOnly) {
      const corpCookie = this.cookieHelper.getCookies('corp');
      let corpName = corpCookie.split('|')[1].split('=')[1].replace(/#/g, ' ');
      return corpName;
    }
  }

  getDisplayTravelType(accountObj, isBusinessText) {
    if (isBusinessText) {
      return accountObj.initialBusinessType.businessLoginDisplayText;
    }
    return accountObj.initialBusinessType.personalLoginDisplayText;
  }

  setAlertAdvisoryClass(isAlertAdvisory) {
    let classObj;
    if (isAlertAdvisory) {
      classObj = Object.assign({}, this.config, {
        class:
          'loggedIn-modal-dialog loggedIn-alertAdv-modal-dialog no-transform'
      });
    } else {
      classObj = Object.assign({}, this.config, {
        class: 'loggedIn-modal-dialog no-transform'
      });
    }
    return classObj;
  }

  setBsModalRefClass(obj, crpInfo) {
    this.bsModalRef = this.modalService.show(FlyoutLoggedinUserComponent, obj);
    if (document.body.scrollWidth > 992) {
      this.bsModalRef.content.profilePickerModalLoaded = true;
      document
        .getElementsByTagName('modal-container')[0]
        .classList.add('notification-loggedin-modal');
      this.modalServiceRef.emit(this.bsModalRef);
    } else if (document.body.scrollWidth > 767) {
      this.bsModalRef.content.profilePickerModalLoaded = true;
      document
        .getElementsByTagName('modal-container')[0]
        .classList.add('notification-loggedin-modal');
    } else {
      this.bsModalRef.content.isFlyoutLoaded = true;
      document
        .getElementsByClassName('feed-header')[0]
        .classList.add('feed-header-fixed');
    }
    if (this.bsModalRef) {
      this.bsModalRef.content.focusActiveTab();
      this.bsModalRef.content.setModalHeight();
      this.bsModalRef.content.setCorpInfo(crpInfo);
      const flyToggle = this.el.nativeElement.querySelector('.toggle-flyout');
      flyToggle.className = 'toggle-flyout toggle-up';
    }
  }

  setHtmlRootClass() {
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
  }

  getModalServiceDataOnHidden() {
    return this.modalService.onHidden
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (reason: string) => {
          this.triggerElement1.nativeElement.focus();
          const toggleFlyout =
            this.triggerElement1.nativeElement.querySelector('.toggle-flyout');
          if (toggleFlyout !== undefined) {
            toggleFlyout.className = 'toggle-flyout';
          }
          this.modalServiceRef.emit(null);
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  setNewProfileSelectorModal() {
    this.showModal = !this.showModal;
    const body = document.body;
    const event = new CustomEvent('profile-selector-click', {
      bubbles: true
    });
    document.dispatchEvent(event);
    const elementTag: HTMLElement = document.querySelector(
      'idp-login-modal-profile-selector'
    );
    if (elementTag) {
      this.showModal = true;
      this.renderer.addClass(body, 'modal-open');
      elementTag?.setAttribute('fromProfileSelector', 'true');
      elementTag?.setAttribute('shouldcallservice', 'false');
    } else {
      this.showModal = false;
      elementTag?.setAttribute('fromProfileSelector', 'false');
      elementTag?.setAttribute('shouldcallservice', 'false');
      this.renderer.removeClass(body, 'modal-open');
    }
  }
}
